import ReactDOM from "react-dom/client";
import App from "./App";

import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import communityFinderStore from "./system/redux/store/community-finder-redux-store";

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement,
);

root.render(
	<BrowserRouter>
		<Provider store={communityFinderStore}>
			<App />
		</Provider>
	</BrowserRouter>,
);
